var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcTravelPlanBrowseLocals(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "17px",
    viewBox: "0 0 17 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icTravelPlanBrowseLocals") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.6328981,12.8064487 L11.374225,9.56145297 C11.3569066,9.54420695 11.3365919,9.53215265 11.3184945,9.51610013 C11.9596943,8.5475186 12.3339273,7.3880971 12.3339273,6.14125203 C12.3339273,2.74951597 9.57287305,2.66453526e-14 6.16696363,2.66453526e-14 C2.7610542,2.66453526e-14 0,2.74951597 0,6.14119236 C0,9.53280907 2.76099428,12.2823847 6.1669037,12.2823847 C7.41904104,12.2823847 8.58326808,11.9097156 9.55591422,11.2711954 C9.5720341,11.2891575 9.58407907,11.3093873 9.60139746,11.3266333 L12.8601306,14.5717484 C13.3496596,15.0591721 14.1433092,15.0591721 14.6328981,14.5717484 C15.1223673,14.084265 15.1223673,13.2939321 14.6328981,12.8064487 Z M6.16696363,10.1534269 C3.94170076,10.1534269 2.13783199,8.35709635 2.13783199,6.14119236 C2.13783199,3.92522869 3.94176068,2.12889815 6.16696363,2.12889815 C8.39210665,2.12889815 10.1960353,3.92528836 10.1960353,6.14119236 C10.1960353,8.35709635 8.39210665,10.1534269 6.16696363,10.1534269 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Travel",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Travel_PopularDestinations",
    transform: "translate(-1101.000000, -196.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-69",
    transform: "translate(1092.000000, 192.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/GeneralNavigation/DiscoverOultine",
    transform: "translate(9.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "musica-searcher",
    transform: "translate(0.200000, 0.480000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "colour/BlueGray"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icTravelPlanBrowseLocals",
    transform: "translate(0.800000, 0.520000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    stroke: "#333333",
    strokeWidth: 0.7,
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTravelPlanBrowseLocals);
export default __webpack_public_path__ + "static/media/icTravelPlanBrowseLocals.402f862e0efa059df6b0cea4ca72ba37.svg";
export { ForwardRef as ReactComponent };